import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_EMPLOYEES_IMPORTS_STATS, KEY_GET_EMPLOYEES_IMPORTS_STATS } from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_STATS } from '../mocks';

type RequestEmployeesImportsStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY
>['request']['path'];

type ResponseEmployeesImportsStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployeesImportsStats = Omit<
  RequestEmployeesImportsStats,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployeesImportsStats = ResponseEmployeesImportsStats;

type CallErrorGetEmployeesImportsStats = GenericApiError;

type CallSelectorsGetEmployeesImportsStats = {
  total: number;
  completed: number;
  invalid: number;
  issuesList: ResponseEmployeesImportsStats['issues'];
};

export const getEmployeesImportsStatsCall = createGeneralCall<
  CallParamsGetEmployeesImportsStats,
  CallResponseGetEmployeesImportsStats,
  CallErrorGetEmployeesImportsStats,
  CallSelectorsGetEmployeesImportsStats
>({
  id: KEY_GET_EMPLOYEES_IMPORTS_STATS,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_EMPLOYEES_IMPORTS_STATS(org, payload?.jobId || '');
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_STATS : undefined,
  selectors: {
    total: ({ selectors }) => createSelector(selectors.response, res => res?.total || 0),
    completed: ({ selectors }) => createSelector(selectors.response, res => res?.completed || 0),
    invalid: ({ selectors }) => createSelector(selectors.response, res => res?.invalid || 0),
    issuesList: ({ selectors }) => createSelector(selectors.response, res => res?.issues || []),
  },
});
